import React, { useEffect } from 'react';
import { DefaultButton, IContextualMenuItem } from '@fluentui/react';
import FilterPanel, { FilterOptionProps } from '../../../../../uiframeworks/filters/panel';
import SubsidiariesService from '../../../../../../services/data/subsidiaries';
import UserService from '../../../../../../services/users/user';
import PaymentMethods from '../../../../../../manifests/paymentMethods';
import ISubsidiariesResourceShort from '../../../../../../props/data/subsidiaries';
import { IUserResourceShortProps } from '../../../../../../props/users/user';

interface IncomePaymentsListFilterButtonProps {
    filters?: TFilterBy[];
    selected: FilterOptionProps[];
    onChange(selected: FilterOptionProps[]): void;
}

export type TFilterBy = 'subsidiary' | 'customer' | 'method';

const IncomePaymentsListFilterButton: React.FC<IncomePaymentsListFilterButtonProps> = (props: IncomePaymentsListFilterButtonProps) => {
    const [activeSurface, setActiveSurface] = React.useState<string | undefined>();
    const [by, setBy] = React.useState<string | undefined>();
    const [selected, setSelected] = React.useState<FilterOptionProps[]>(props.selected);

    useEffect(() => {
        setSelected(props.selected);
    }, [props.selected]);

    const _onFilterApplied = (_selected: FilterOptionProps[]) => {
        props.onChange(_selected);
        setActiveSurface(undefined);
        setBy(undefined);
    }

    const _onCancelled = () => {
        setBy(undefined);
        setActiveSurface(undefined);
    }

    const _onRenderOptions = async (): Promise<FilterOptionProps[]> => {
        if (by) {
            const key = by.toLowerCase().split(" ").join("_");
            const options: FilterOptionProps[] = [];

            if (key === 'subsidiary') {
                const results = (await SubsidiariesService.retrieve("top=all"));
                results.forEach((res: ISubsidiariesResourceShort) => {
                    options.push({
                        filterby: key,
                        filterbyText: 'Subsidiary',
                        key: res.id,
                        title: res.name,
                        description: res.npwp,
                        metadata: res
                    });
                });
            } else if (key === 'customer') {
                const results = (await UserService.retrieve("rolesGroup=customer&top=all")).data;
                results.forEach((res: IUserResourceShortProps) => {
                    options.push({
                        filterby: key,
                        filterbyText: 'Customer',
                        key: res.id,
                        title: res.name,
                        metadata: res
                    });
                });
            } else if (key === 'method') {
                PaymentMethods.forEach((pm) => {
                    options.push({
                        filterby: key,
                        filterbyText: 'Payment Method',
                        key: pm.key,
                        title: pm.text,
                        metadata: pm
                    });
                });
            }

            return options;
        } else {
            return [];
        }
    }

    const renderFilterButton = () => {
        const items: IContextualMenuItem[] = [];
        const filteredby: string[] | undefined = props.filters ? (props.filters || []).map((f) => f.toLowerCase()) : undefined;

        if (!filteredby || (filteredby || "").indexOf('subsidiary') > -1) {
            items.push({
                key: 'subsidiary',
                text: 'By subsidiary',
                onClick: () => {
                    setBy('subsidiary');
                    setActiveSurface('filter');
                }
            });
        }

        if (!filteredby || (filteredby || "").indexOf('customer') > -1) {
            items.push({
                key: 'customer',
                text: 'By customer',
                onClick: () => {
                    setBy('customer');
                    setActiveSurface('filter');
                }
            });
        }

        if (!filteredby || (filteredby || "").indexOf('method') > -1) {
            items.push({
                key: 'method',
                text: 'By payment method',
                onClick: () => {
                    setBy('method');
                    setActiveSurface('filter');
                }
            });
        }

        return <DefaultButton menuIconProps={{ iconName: "Filter" }} text={"Filter"} menuProps={{ items }} />
    }

    return <>
        {renderFilterButton()}
        {activeSurface === 'filter' && by ? <>
            <FilterPanel title={"Filter by " + by}
                onRenderOptions={_onRenderOptions}
                selected={selected}
                onCancel={_onCancelled}
                onApply={_onFilterApplied} />
        </> : null}
    </>
};

export default IncomePaymentsListFilterButton;
